import {Injectable, InjectionToken} from "@angular/core";

/**
 * Base class for the the two configuration services.
 */
@Injectable()
export abstract class ConfigurationServiceConstants {
    static configSpecPattern = /(.*?)\/(.*)/;

    /**
     * Provider application key - identifies the application in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly APPLICATION_KEY: InjectionToken<string> = new InjectionToken<string>('applicationKey');

    /**
     * Provider context names key - specifies the order of context names in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly CONTEXT_NAMES_KEY: InjectionToken<string> = new InjectionToken<string>('contextNames');

    /**
     * Provider local config file key - specifies the location of the local config file.
     * @type {InjectionToken}
     */
    public static readonly LOCAL_CONFIG_FILE_KEY: InjectionToken<string> = new InjectionToken<string>('localConfigFile');

    /**
     * Key for locally stored configuraions
     * @type {string}
     */
    public static readonly LOCAL_STORAGE_KEY = "localConfigurations";

    /**
     * Add the specified configuration to the given configurations map.
     * @param configurations
     * @param category
     * @param configName
     * @param contextSpecKey
     * @param contextSpec
     * @param value
     */
    public static setConfiguration(configurations: any, category: string, configName: string, contextSpecKey: string, contextSpec: {[contextName: string]: string}, value: string) {
        if (!configurations.hasOwnProperty(category)) {
            configurations[category] = {};
        }
        let configurationMap: {[configName: string]: {[contextSpecKey: string]: string}} = configurations[category];
        if (!configurationMap.hasOwnProperty(configName)) {
            configurationMap[configName] = {};
        }
        let contextSpecMap: {[contextSpecKey: string]: string} = configurationMap[configName];
        contextSpecMap[contextSpecKey] = value;

        if (!configurations.hasOwnProperty("contextSpecs")) {
            configurations["contextSpecs"] = {};
        }
        let contextSpecs: {[contextSpecKey: string]: {[contextName: string]: string}} = configurations['contextSpecs'];
        contextSpecs[contextSpecKey] = contextSpec;
    }
}
